/**
 * Tasks — canonical admin task manager (flowstate-automate parity).
 *
 * Renders ProfessionalTodoList (board/list, stats, filters, assignments, sync).
 * Track 6 server/hooks (useTasks) remain for API/tests; UI uses TodoService stack.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import ProfessionalTodoList from "@/components/admin/todos/ProfessionalTodoList";
import { useVerificationStudio, VerificationTaskBoard } from "@/features/verification-studio";

const tasksSearchSchema = z.object({
  openTask: z.string().uuid().optional(),
  tab: z.string().optional(),
  filter: z.coerce.boolean().optional(),
});

export const Route = createFileRoute("/_admin/tasks/")({
  validateSearch: tasksSearchSchema,
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  pendingComponent: () => <PageSkeleton rows={8} variant="list" />,
  errorComponent: createRouteError("Tasks"),
  component: TasksPage,
});

function TasksPage() {
  const { enabled } = useVerificationStudio();
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {enabled ? <VerificationTaskBoard /> : <ProfessionalTodoList mode="admin" />}
    </div>
  );
}
